/* eslint no-undef: 0 */

import React from 'react';
import Select from 'react-select';

declare var brandColor: any;

interface StyledMultiselectProps {
  classes?: string,
  options: any[],
  handleChange: any,
  values: any[],
}

export default class StyledMultiselect extends React.Component<StyledMultiselectProps, any> {
  static defaultProps = {
    classes: '',
  }

  render() {
    return (
      <Select
        className={this.props.classes}
        isMulti
        options={this.props.options}
        onChange={this.props.handleChange}
        values={this.props.values}
        theme={this.getTheme()}
      />
    );
  }

  getTheme = () => {
    return (theme: any) => {
      return {
        ...theme,
        colors: {
          ...theme.colors,
          primary50: '#E8EBED',
          primary25: '#E8EBED',
          primary: '#E8EBED',
        },
      };
    };
  }
}
